import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

class TableBodyRow extends PureComponent {
  renderRowCells(item) {
    const { config } = this.props;

    return config.map((conf, index) => {
      const value = _get(item, conf.dataField, '');
      const cell = conf.renderCell ? conf.renderCell(value, item) : value;

      return (
        <td key={index} padding={conf.padding} align={conf.align}>
          {cell}
        </td>
      );
    });
  }

  render() {
    const { idProperty, item, onRowClick } = this.props;

    return (
      <tr id={_get(item, idProperty)} onClick={onRowClick}>
        {this.renderRowCells(item)}
      </tr>
    );
  }
}

TableBodyRow.propTypes = {
  config: PropTypes.arrayOf(PropTypes.shape).isRequired,
  item: PropTypes.shape({}).isRequired,
  idProperty: PropTypes.string.isRequired,
  onRowClick: PropTypes.func,
};

TableBodyRow.defaultProps = {
  onRowClick: () => {},
};

export default TableBodyRow;
